module.exports = __webpack_public_path__ + "img/Logo 1.76a9839a.png";